import { useMemoizedFn } from 'ahooks'
import { createStore, useStore } from 'zustand'

type EditableInputStore = {
  activeId?: string
  toggleActive: (id: string) => void
}

const editableInputStore = createStore<EditableInputStore>((set, get) => ({
  activeId: undefined,
  toggleActive: (id: string) =>
    set({ activeId: get().activeId === id ? undefined : id })
}))

export const useEditableInputStore = (id: string) => {
  const store = useStore(editableInputStore)
  const toggleActive = useMemoizedFn(() => {
    store.toggleActive(id)
  })

  return {
    ...store,
    toggleActive
  }
}
